import React from 'react';
import * as _ from 'lodash';
import { layoutInit, client } from '../canvas/constructionPlacement/';
import $ from 'jquery';

import urlParamManger from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import * as pages from '../components/pageComponents';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { isPartnerCompanyRoleId } from '../utilities/roleUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import {
  ArrowIcon,
  PointerArrowIcon,
  PointerCircleIcon,
  SolidLineTypeIcon,
  LineDotIcon,
  LineDashIcon,
  ToolPointerIcon,
  ToolUndoIcon,
  ToolRedoIcon,
  ToolSelectIcon,
  ToolFontIcon,
  ToolImageIcon,
  ToolPartsIcon,
  ToolShapeIcon,
  ToolShapeCircleIcon,
  ToolShapeSquareIcon,
  ToolShapePolygonIcon,
  ToolLineIcon,
  ToolLineNormalIcon,
  ToolLinePolylineIcon,
  ToolLineFreeHandIcon,
  ToolCopyCanvasIcon,
  ToolPanIcon,
  ToolBackgroundIcon,
  ToolCutIcon,
  ToolCopyIcon,
  ToolPasteIcon,
  ToolPrintRangeIcon,
  ToolPrintCanvasIcon,
  ToolGroupIcon,
  ToolUnGroupIcon,
  ToolMoveFrontIcon,
  ToolMoveBackIcon,
  ToolLockIcon,
  ToolUnLockIcon,
  ToolDeleteIcon,
  ToolInfoIcon,
  ToolMultiScreenIcon,
  ToolPrevIcon,
  ToolNextIcon,
  ToolZoomDownIcon,
  ToolZoomUpIcon,
  ToolShapeSectorIcon,
} from '../canvas/icon/LayoutIcon';
import Tippy from '../components/ReactTippy';

export default class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.fullScreanMode = false;
    this.stylesheets = ['/drawing/css/canvas.css'];
    this.role_id = parseInt(localStorage.getItem('role_id'), 10);
    this.state = {
      splitItem: 1,
      hasObjectSelected: false,
      isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    };
    this.webkitTapHighlightColorTransparent = {
      WebkitTapHighlightColor: 'transparent',
      touchAction: 'manipulation',
    };
    this.handleUpdateStateEvent = this.handleUpdateStateEvent.bind(this);
  }

  loadStylesheets(link) {
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.media = 'all';
    l.href = link;
    l.className = 'load-stylesheet';
    document.head.appendChild(l);
  }

  removeStylesheets() {
    const stylesheets = document.head.getElementsByClassName('load-stylesheet');
    const cnt = stylesheets.length;
    for (let i = 0; i <= cnt; i++) {
      const remove = document.head.getElementsByClassName('load-stylesheet');
      if (remove[0] !== undefined) {
        document.head.removeChild(remove[0]);
      }
    }
  }

  // iPad画面が動かないようにする
  preventBehavior(e) {
    e.preventDefault();
  }

  componentDidMount() {
    // Hide master menu & function menu
    $('.sys_fullscreen').trigger('click');
    this.removeStylesheets();
    _.each(this.stylesheets, stylesheet => {
      this.loadStylesheets(stylesheet);
    });
    layoutInit(this.props.param[1]);
    // BLDE_V2-16512対応（touchmoveイベントの無効化が場所選択まで影響していたのを回避）
    const editCanvas = document.querySelector('.edit_canvas');
    editCanvas.addEventListener('touchmove', this.preventBehavior, {
      passive: false,
    });
    window.addEventListener(
      EventType.LAYOUT_LOADING,
      this.handleUpdateStateEvent
    );
  }

  componentWillUnmount() {
    client.endConnect();
    if (this.fullScreanMode) {
      this.fullScrean();
    }
    window.removeEventListener(
      EventType.LAYOUT_LOADING,
      this.handleUpdateStateEvent
    );
  }

  placeList = () => {
    urlParamManger.setPage(`ConstructionPlacementPlace:1`, this.props.vw);
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    // Add empty arrays, avoid errors when load page
    this.props.loadPage(pages.ConstructionPlacementPlace, []);
    urlParamManger.publish();
  };

  fullScrean = () => {
    this.fullScreanMode = !this.fullScreanMode;
    EventManager.trigger(EventType.FULL_SCREAN_MODE, this.fullScreanMode);
    SessionStorageService.setOpeningMasterMenu(!this.fullScreanMode);
    SessionStorageService.setOpeningFunctionMenu(!this.fullScreanMode);
  };

  setNumberSplitItem = splitItem => {
    this.setState({
      splitItem,
    });
  };
  handleUpdateStateEvent = event => {
    const { hasObjectSelected } = event.detail;
    this.setState({ hasObjectSelected });
  };

  ShowToolTip = ({ message, children, disable = false }) => {
    const { isTouchDevice } = this.state;
    return (
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        arrow={true}
        delay={[100, 0]}
        placement='bottom'
        followCursor={true}
        html={
          <div
            className='layout-tippy-tooltip'
            dangerouslySetInnerHTML={{ __html: message }}
          ></div>
        }
        disable={disable || isTouchDevice}
      >
        {children}
      </Tippy>
    );
  };

  preventDefault = e => e.preventDefault();

  render() {
    const { splitItem, hasObjectSelected } = this.state;
    const iconArrow = (top, isDropdownEl) => {
      let className = '';
      if (top) {
        className = 'rotate-to-top';
      }
      if (isDropdownEl) {
        className += ' i-2x';
      } else {
        className += ' i-2x_2';
      }
      return (
        <i className={`${className}`}>
          <ArrowIcon />
        </i>
      );
    };

    return (
      <div id='main' className='main layout_main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 現場配置計画</title>
        </Helmet>
        <div
          className='main__header main__header__layout'
          onClick={this.preventDefault}
          style={this.webkitTapHighlightColorTransparent}
        >
          <div className='layout-header'>
            <div className={'layout-header__wrapper'}>
              <div className='layout-header__title'>現場配置計画作成</div>
              <div className='layout-header__menu'>
                <div
                  className='layout-header__fullscreen sys_fullscreen'
                  data-fullscreen='true'
                  onClick={() => this.fullScrean()}
                >
                  フルスクリーンモード :
                  <div className='fullscreen'>
                    <span className='fullscreen__text'>
                      {this.fullScreanMode ? 'ON' : 'OFF'}
                    </span>
                  </div>
                </div>
                <div
                  className='layout-header__lock sys_lock_room'
                  style={{ display: 'none' }}
                >
                  職長作業ロック :
                  <div className='lock'>
                    <span className='lock__text' />
                    <button className='lock__btn' />
                  </div>
                </div>
                <div className='layout-header__info'>
                  <label>オブジェクト配置数 : </label>
                  <span className='object_count' />
                  <span className='object_max_count' />
                </div>
                <div
                  className='layout-header__close-button'
                  onClick={() => this.placeList()}
                >
                  場所一覧に戻る
                  <button className='btn-icon--sm'>
                    <i className='i-close--dark i-3x' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='btn-toolbar-toggle'>
          <button className='btn-text toolbar-open'>
            ツールバーを表示する
          </button>
          <button className='btn-text toolbar-close'>
            ツールバーを非表示にする
          </button>
        </div>
        <div className='main__body layout_body'>
          <div className='layout'>
            <div className='tool-item-list tool-crane__dropdown'>
              <div className='tool-crane__body parts_group_dropdown'>
                <ul className='dropdown-tool-list parts_group_list' />
              </div>
            </div>
            <div
              className='layout-tool-tabs layout-tool-fix'
              onClick={this.preventDefault}
              style={this.webkitTapHighlightColorTransparent}
            >
              <ul>
                <li
                  className='tab-link active'
                  id='tab-tool-home__link'
                  data-tab='tab-tool-home'
                >
                  ホーム
                </li>
                {this.ShowToolTip({
                  message: '編集するオブジェクトを選択してください。',
                  disable: hasObjectSelected,
                  children: (
                    <li
                      className='tab-link disable'
                      id='tab-tool-edit__link'
                      data-tab='tab-tool-edit'
                    >
                      オブジェクトの編集
                    </li>
                  ),
                })}
              </ul>
            </div>
            <div
              className='layout-tool layout-tool-fix'
              onClick={this.preventDefault}
              style={{
                ...this.webkitTapHighlightColorTransparent,
                display: 'none',
              }}
            >
              <div className='tab-content active' id='tab-tool-home'>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '戻す(Ctrl+Z)',
                      children: (
                        <button className='tool-btn toolbar-undo btn-icon'>
                          <i className='i-3x' alt='１つ戻る'>
                            <ToolUndoIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>１つ戻る</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'やり直す(Ctrl+Y)',
                      children: (
                        <button className='tool-btn toolbar-redo btn-icon'>
                          <i className='i-3x' alt='１つ進む'>
                            <ToolRedoIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>１つ進む</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを選択(A)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip tool-select btn-icon'
                          data-id='tool-select'
                        >
                          <i className='i-3x' alt='選択'>
                            <ToolSelectIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>選択</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'テキストを配置(T)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip tool-font btn-icon'
                          data-id='tool-font'
                        >
                          <i className='i-3x' alt='テキスト'>
                            <ToolFontIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>テキスト</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <button
                      className='tool-btn sys_tooltip tool-image btn-icon hover-image'
                      data-id='tool-image'
                    >
                      <i className='i-3x' alt='画像配置'>
                        <ToolImageIcon />
                      </i>
                    </button>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>画像</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <div className='tool-item-list tool-crane'>
                      <div className='tool-crane__header'>
                        <button
                          className='tool-btn tool-parts-button tool-btn__arrow-down btn-icon'
                          data-id='tool-parts-button'
                        >
                          <i className='i-3x' alt='部品配置'>
                            <ToolPartsIcon />
                          </i>
                          {iconArrow(false, false)}
                        </button>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>アイテム</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <div className='tool-item--sm tool-item-list tool-object-list'>
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-shape-button tool-btn__arrow-down btn-icon'
                          data-id='tool-shape-button'
                        >
                          <i
                            className='i-3x tool-object-icon icon-default'
                            alt='図形配置'
                          >
                            <ToolShapeIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-circle'
                            alt='丸配置'
                          >
                            <ToolShapeCircleIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-square'
                            alt='四角配置'
                          >
                            <ToolShapeSquareIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-polygon'
                            alt='多角形配置'
                          >
                            <ToolShapePolygonIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-sector'
                            alt='扇形配置'
                          >
                            <ToolShapeSectorIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-circle'
                          >
                            {this.ShowToolTip({
                              message: '	円(C)',
                              children: (
                                <button className='img-tool-object tool-circle'>
                                  <ToolShapeCircleIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-square'
                          >
                            {this.ShowToolTip({
                              message: '四角(R)',
                              children: (
                                <button className='img-tool-object tool-square'>
                                  <ToolShapeSquareIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-polygon'
                          >
                            {this.ShowToolTip({
                              message: '多角形(M)',
                              children: (
                                <button className='img-tool-object tool-polygon'>
                                  <ToolShapePolygonIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-sector'
                          >
                            {this.ShowToolTip({
                              message: '扇形(F)',
                              children: (
                                <button className='img-tool-object tool-sector'>
                                  <ToolShapeSectorIcon />
                                </button>
                              ),
                            })}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span className='selected-object-label icon-default'>
                          図形
                        </span>
                        <span className='selected-object-label icon-circle'>
                          円
                        </span>
                        <span className='selected-object-label icon-square'>
                          四角
                        </span>
                        <span className='selected-object-label icon-polygon'>
                          多角形
                        </span>
                        <span className='selected-object-label icon-sector'>
                          扇形
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <div className='tool-item--sm tool-item-list tool-line-list'>
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-line-button tool-btn__arrow-down btn-icon'
                          data-id='tool-line-button'
                        >
                          <i
                            className='i-3x tool-line-icon icon-default'
                            alt='線配置'
                          >
                            <ToolLineIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-line-normal'
                            alt='直線配置'
                          >
                            <ToolLineNormalIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-polyline'
                            alt='折れ線配置'
                          >
                            <ToolLinePolylineIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-freehand'
                            alt='自由線配置'
                          >
                            <ToolLineFreeHandIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item  sys_tooltip'
                            data-id='tool-line-normal'
                          >
                            {this.ShowToolTip({
                              message: '	直線(L)',
                              children: (
                                <button className='img-tool-line i-tool-line-1 btn-icon'>
                                  <i className='i-3x' alt='線配置'>
                                    <ToolLineNormalIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-polyline'
                          >
                            {this.ShowToolTip({
                              message: '折れ線(Alt+L)',
                              children: (
                                <button className='img-tool-line i-tool-line-2 btn-icon'>
                                  <i className='i-3x'>
                                    <ToolLinePolylineIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-freehand'
                          >
                            {this.ShowToolTip({
                              message: '	自由線(Shift+Alt+L)',
                              children: (
                                <button className='img-tool-line i-tool-line-3 btn-icon'>
                                  <i className='i-3x'>
                                    <ToolLineFreeHandIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span className='selected-line-label icon-default'>
                          線
                        </span>
                        <span className='selected-line-label icon-line-normal'>
                          直線
                        </span>
                        <span className='selected-line-label icon-polyline'>
                          折れ線
                        </span>
                        <span className='selected-line-label icon-freehand'>
                          自由線
                        </span>
                      </div>
                    </div>
                  </div>
                  {!isPartnerCompanyRoleId(this.role_id) && (
                    <div className='layout-tool__item'>
                      <button className='tool-btn sys_popup_copy btn-icon'>
                        <i className='i-3x' alt='別日/別場所からコピー'>
                          <ToolCopyCanvasIcon />
                        </i>
                      </button>
                      <div className='layout-tool__label'>
                        <div className='label'>
                          <span>別日/別場所</span>
                          <span>からコピー</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '背景を移動(Space)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip btn-icon'
                          data-id='tool-pan'
                        >
                          <i className='i-3x' alt='背景移動'>
                            <ToolPanIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>背景移動</span>
                      </div>
                    </div>
                  </div>
                  {!isPartnerCompanyRoleId(this.role_id) && (
                    <div className='layout-tool__item'>
                      <button className='tool-btn select-bg-image btn-icon'>
                        <i className='i-3x' alt='背景変更'>
                          <ToolBackgroundIcon />
                        </i>
                      </button>
                      <div className='layout-tool__label'>
                        <div className='label'>
                          <span>背景設定</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを切り取り(Ctrl+X)',
                      children: (
                        <button className='tool-btn toolbar-cut btn-icon'>
                          <i className='i-3x' alt='切り取り'>
                            <ToolCutIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>カット</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをコピー(Ctrl+C)',
                      children: (
                        <button className='tool-btn toolbar-copy btn-icon'>
                          <i className='i-3x' alt='コピー'>
                            <ToolCopyIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>コピー</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを貼り付け(Ctrl+V)',
                      children: (
                        <button className='tool-btn toolbar-paste btn-icon'>
                          <i className='i-3x' alt='貼り付け'>
                            <ToolPasteIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>貼り付け</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group' id='tool-pointer-section'>
                  <div className='layout-tool__item'>
                    <div className='tool-item--sm tool-item-list tool-object-list tool-object-list-pointer'>
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-pointer-button tool-btn__arrow-down btn-icon'
                          data-id='tool-pointer-button'
                          data-value='0'
                        >
                          <i
                            data-id='tool-pointer-selected'
                            className='i-3x tool-pointer-icon icon-default'
                            alt='ポインタ'
                          >
                            <ToolPointerIcon />
                          </i>
                          <i
                            data-id='tool-pointer-selected'
                            className='i-3x tool-pointer-icon icon-circle-s2'
                            alt='丸ポインタ'
                          >
                            <PointerCircleIcon />
                          </i>
                          <i
                            data-id='tool-pointer-selected'
                            className='i-3x tool-pointer-icon icon-arrow-pointer'
                            alt='矢印ポインタ'
                          >
                            <PointerArrowIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-pointer'
                          >
                            {this.ShowToolTip({
                              message: 'ポインター(P)',
                              children: (
                                <button className='img-tool-pointer i-circle-s2 btn-icon'>
                                  <i className='i-3x'>
                                    <PointerCircleIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-arrow-pointer'
                          >
                            {this.ShowToolTip({
                              message: '矢印ポインター(Alt+P)',
                              children: (
                                <button className='img-tool-pointer i-cursor-right btn-icon'>
                                  <i className='i-3x'>
                                    <PointerArrowIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span className='selected-pointer-label icon-default'>
                          ポインター
                        </span>
                        <span className='selected-pointer-label icon-arrow-pointer'>
                          矢印ポインター
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group layout-tool__group--end'>
                  <div className='layout-tool__item'>
                    <button className='tool-btn sys_open_print_range btn-icon'>
                      <i className='i-3x' alt='印刷範囲設定'>
                        <ToolPrintRangeIcon />
                      </i>
                    </button>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>印刷範囲</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <button className='tool-btn toolbar-canvas-copy-popup btn-icon'>
                      <i className='i-3x' alt='印刷'>
                        <ToolPrintCanvasIcon />
                      </i>
                    </button>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>印刷</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tab-content' id='tab-tool-edit'>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-background'>
                      <div className='btn-pick-color btn-pick-color-background _selected __none' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __empty'
                              data-id='empty'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>塗り</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-background-transparent'
                      className='tool-item--sm'
                    >
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='塗りの透明度'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='0%'>
                              0%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='5%'>
                              5%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='10%'>
                              10%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='15%'>
                              15%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='20%'>
                              20%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='25%'>
                              25%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='30%'>
                              30%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='35%'>
                              35%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='40%'>
                              40%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='45%'>
                              45%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='50%'>
                              50%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='55%'>
                              55%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='60%'>
                              60%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='65%'>
                              65%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='70%'>
                              70%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='75%'>
                              75%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='80%'>
                              80%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='85%'>
                              85%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='90%'>
                              90%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='95%'>
                              95%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='100%'>
                              100%
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>透明度</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-foreground'>
                      <div className='btn-pick-color btn-pick-color__line _selected __111111' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __empty'
                              data-id='empty'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の色</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className='layout-tool__item tool-setting-style'
                    id='dropdown-border-section'
                  >
                    <div
                      id='dropdown-border-style'
                      className='tool-item--sm tool-item-list'
                    >
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon'
                          data-id='tool-line-style-button'
                          data-value='1'
                        >
                          <i className='i-3x'>
                            <SolidLineTypeIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon dotted-line-style'
                          data-id='tool-line-style-button'
                          data-value='2'
                        >
                          <i className='i-3x'>
                            <LineDotIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon dashed-line-style'
                          data-id='tool-line-style-button'
                          data-value='3'
                        >
                          <i className='i-3x'>
                            <LineDashIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-solid_line'
                          >
                            <button
                              className='tool-list-btn tool-solid_line btn-icon'
                              data-value='実線'
                            >
                              <i className='i-3x'>
                                <SolidLineTypeIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>実線</span>
                            </span>
                          </li>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-dotted-line'
                          >
                            <button
                              className='tool-list-btn tool-dotted-line btn-icon'
                              data-value='点線'
                            >
                              <i className='i-3x'>
                                <LineDotIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>点線</span>
                            </span>
                          </li>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-dashed-line'
                          >
                            <button
                              className='tool-list-btn btn-icon tool-dashed-line'
                              data-value='鎖線'
                            >
                              <i className='i-3x'>
                                <LineDashIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>鎖線</span>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の種類</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div id='dropdown-border' className='tool-item--sm'>
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='線の太さ'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='1pt'>
                              1pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='4pt'>
                              4pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='8pt'>
                              8pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='12pt'>
                              12pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='16pt'>
                              16pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='20pt'>
                              20pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='32pt'>
                              32pt
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の太さ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-border-arrow'
                      className='tool-arrow-type tool-item--sm'
                    >
                      <div className='tool-arrow-type__header'>
                        <div className='input-spin--sm' alt='矢印の種類'>
                          <div className='tool-arrow-type__value'>
                            <input type='hidden' />
                            <span className='tool-arrow-type__input-text'>
                              なし
                            </span>
                          </div>
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-arrow-type__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-1'
                              data-value='0'
                            >
                              なし
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-2'
                              data-value='1'
                            >
                              終点
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-3'
                              data-value='2'
                            >
                              始点
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-4'
                              data-value='3'
                            >
                              両端
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>矢印の向き</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-border-arrow-size'
                      className='tool-line-size tool-item--sm'
                    >
                      <div className='tool-line-size__header'>
                        <div className='input-spin--sm' alt='矢印のサイズ'>
                          <div className='tool-line-size__value'>
                            <input type='hidden' />
                            <span className='tool-arrow-size__input-text img-tool-line-size selected-icon'>
                              小
                            </span>
                          </div>
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-line-size__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-1'
                              data-value='10'
                            >
                              小
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-2'
                              data-value='20'
                            >
                              中
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-3'
                              data-value='30'
                            >
                              大
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>矢印の</span>
                        <span>サイズ</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-text'>
                      <div className='btn-pick-color btn-pick-color__text _selected __111111' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __empty'
                              data-id='empty'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>文字の色</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div id='dropdown-font-size' className='tool-item--sm'>
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='文字の大きさ'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='9pt'>
                              9pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='10pt'>
                              10pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='11pt'>
                              11pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='12pt'>
                              12pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='14pt'>
                              14pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='18pt'>
                              18pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='24pt'>
                              24pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='28pt'>
                              28pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='32pt'>
                              32pt
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>文字の</span>
                        <span>サイズ</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをグループ化(Ctrl+G)',
                      children: (
                        <button className='tool-btn toolbar-group btn-icon'>
                          <i className='i-3x' alt='グループ化'>
                            <ToolGroupIcon />
                          </i>
                        </button>
                      ),
                    })}
                    {this.ShowToolTip({
                      message: 'クループ化を解除(Ctrl+Shift+G)',
                      children: (
                        <button className='tool-btn toolbar-ungroup btn-icon'>
                          <i className='i-3x' alt='グループ解除'>
                            <ToolUnGroupIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label label-group'>
                        <span>グループ化</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '前面へ移動(Alt+] )<br/>最前面へ移動( ] )',
                      children: (
                        <button className='tool-btn toolbar-move-front btn-icon'>
                          <i className='i-3x' alt='最前面へ'>
                            <ToolMoveFrontIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>最前面へ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '背面へ移動(Alt+[ )<br/>最背面へ移動( [ )',
                      children: (
                        <button className='tool-btn toolbar-move-back btn-icon'>
                          <i className='i-3x' alt='最背面へ'>
                            <ToolMoveBackIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>最背面へ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをロック(Ctrl+Shift+L) ',
                      children: (
                        <button className='tool-btn toolbar-lock btn-icon'>
                          <i className='i-3x' alt='オブジェクトのロック'>
                            <ToolLockIcon />
                          </i>
                        </button>
                      ),
                    })}
                    {this.ShowToolTip({
                      message: ' ロック状態を解除(Ctrl+Shift+L)',
                      children: (
                        <button className='tool-btn toolbar-unlock btn-icon'>
                          <i className='i-3x' alt='オブジェクトのロック解除'>
                            <ToolUnLockIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label label-lock'>
                        <span>ロック</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを削除(delete)',
                      children: (
                        <button className='tool-btn toolbar-delete btn-icon'>
                          <i className='i-3x' alt='削除'>
                            <ToolDeleteIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>削除</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group layout-tool__group--end'>
                  <div className='layout-tool__item'>
                    <button className='tool-btn toolbar-info btn-icon'>
                      <i className='i-3x' alt='情報'>
                        <ToolInfoIcon />
                      </i>
                    </button>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>情報</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='layout loading'>
              <div className='layout__loading'>
                <div className='indicator' />
                <div
                  id='loading_msg'
                  className='layout__loading--message loading-message'
                >
                  サーバーに接続中
                </div>
                <div
                  id='disconnect_msg'
                  className='layout__loading--message loading-message'
                  style={{ display: 'none' }}
                >
                  サーバとの通信が切れました。
                  <br />
                  ただいま再接続中です。
                  <br />
                  大変申し訳ありませんが、しばらくお待ちください。
                </div>
                <div
                  id='server_err_msg'
                  className='layout__loading--message loading-message'
                  style={{ display: 'none' }}
                >
                  更新処理に失敗しました、10秒後に画面の更新を行います。
                  <br />
                  画面の更新が行われない場合は、お手数ですが
                  <a href='javascript:location.reload();'>こちら</a>{' '}
                  をクリックして下さい。
                </div>
              </div>
            </div>
            <div
              className='layout-grid grid-1'
              onClick={this.preventDefault}
              style={{
                ...this.webkitTapHighlightColorTransparent,
                display: 'none',
              }}
            >
              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_0'
                data-splitno='0'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-0'
                        className='dropdown-calender dropdown-calender--layout-select-header'
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-0' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_1'
                data-splitno='1'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-1'
                        className='dropdown-calender dropdown-calender--layout-select-header'
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-1' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_2'
                data-splitno='2'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-2'
                        className='dropdown-calender dropdown-calender--layout-select-header'
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-2' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_3'
                data-splitno='3'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-3'
                        className='dropdown-calender dropdown-calender--layout-select-header '
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-3' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_4'
                data-splitno='4'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-4'
                        className='dropdown-calender dropdown-calender--layout-select-header '
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-4' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_5'
                data-splitno='5'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-5'
                        className='dropdown-calender dropdown-calender--layout-select-header '
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-5' className='split_canvas' />
                </div>
              </div>
              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_6'
                data-splitno='6'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-6'
                        className='dropdown-calender dropdown-calender--layout-select-header '
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-6' className='split_canvas' />
                </div>
              </div>
              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_7'
                data-splitno='7'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-7'
                        className='dropdown-calender dropdown-calender--layout-select-header '
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-7' className='split_canvas' />
                </div>
              </div>

              <div
                style={{ display: 'none' }}
                className='layout-canvas split-canvas sys_cell_8'
                data-splitno='8'
              >
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <div
                        id='dropdown-calendar-split-8'
                        className='dropdown-calender dropdown-calender--layout-select-header'
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='split_view_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header split-view-select-place'>
                        <div className='dropdown-single-select__header'>
                          <input type='hidden' name='split_view_place_id' />
                          <input
                            type='text'
                            name='split_view_place'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-split-view-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-split-view-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select split-view'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                name='split_view_search_place'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select split-view-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace'>
                  <canvas id='canvas-split-8' className='split_canvas' />
                </div>
              </div>

              <div className='layout-canvas sys_cell_edit'>
                <div className='layout-canvas__header'>
                  <div className='layout-select-header'>
                    <div className='layout-select-header__item'>
                      <label className='label-select-calendar'>作業日</label>
                      <div
                        id='dropdown-calendar'
                        className='dropdown-calender dropdown-calender--layout-select-header'
                      >
                        <div className='dropdown-calender__input'>
                          <input
                            name='hedder_date'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-calender__calender dropdown__item__z-index_101' />
                      </div>
                      <label className='label-select-place'>作業場所</label>
                      <div className='dropdown-single-select dropdown-single-select--layout-select-header select-place'>
                        <div className='dropdown-single-select__header'>
                          <input name='place_id' type='hidden' />
                          <input
                            name='place_name'
                            type='text'
                            autoComplete='off'
                          />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-place-down'>
                              {iconArrow(true)}
                            </div>
                            <div className='select-down btn-icon sys-place-up'>
                              {iconArrow(false)}
                            </div>
                          </div>
                        </div>
                        <div className='dropdown dropdown--dropdown-single-select'>
                          <div className='dropdown__item dropdown__item__z-index_101'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                name='search_place'
                                type='text'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='layout-select-header__printarea print-renge-setting'>
                      <button className='btn--sm--sub sys_cancel_print_range'>
                        やめる
                      </button>
                      <button className='btn-text sys_default_print_range'>
                        デフォルトに戻す
                      </button>
                      <button className='btn--sm--stay sys_save_print_range'>
                        範囲確定
                      </button>
                    </div>
                  </div>
                </div>
                <div className='layout-canvas__workspace edit_canvas'>
                  <canvas className='' id='canvas' />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='layout-tool-footer'
          onClick={this.preventDefault}
          style={this.webkitTapHighlightColorTransparent}
        >
          <div
            className='layout-tool__group'
            onClick={this.preventDefault}
            style={this.webkitTapHighlightColorTransparent}
          >
            <div
              className='layout-tool__item'
              onClick={this.preventDefault}
              style={this.webkitTapHighlightColorTransparent}
            >
              <div className='tool-item tool-multiscreen tool-item-list'>
                <div className='tool-multiscreen__header'>
                  <button
                    className='tool-btn tool-btn__arrow-down btn-icon'
                    onClick={this.preventDefault}
                    style={this.webkitTapHighlightColorTransparent}
                  >
                    <i className='i-3x' alt='画面分割'>
                      <ToolMultiScreenIcon />
                    </i>
                    {iconArrow(false)}
                  </button>
                </div>
                <div className='tool-multiscreen__body'>
                  <ul className='dropdown-tool-list'>
                    <li className='dropdown-tool-list__item-wide '>
                      <button
                        className='tool-list-btn select_split_number'
                        data-id='9'
                        onClick={() => this.setNumberSplitItem(9)}
                      >
                        9画面
                      </button>
                    </li>
                    <li className='dropdown-tool-list__item-wide '>
                      <button
                        className='tool-list-btn select_split_number'
                        data-id='6'
                        onClick={() => this.setNumberSplitItem(6)}
                      >
                        6画面
                      </button>
                    </li>
                    <li className='dropdown-tool-list__item-wide'>
                      <button
                        className='tool-list-btn select_split_number'
                        data-id='4'
                        onClick={() => this.setNumberSplitItem(4)}
                      >
                        4画面
                      </button>
                    </li>
                    <li className='dropdown-tool-list__item-wide '>
                      <button
                        className='tool-list-btn select_split_number'
                        data-id='2'
                        onClick={() => this.setNumberSplitItem(2)}
                      >
                        2画面
                      </button>
                    </li>
                    <li className='dropdown-tool-list__item-wide '>
                      <button
                        className='tool-list-btn select_split_number'
                        data-id='1'
                        onClick={() => {
                          this.setNumberSplitItem(1);
                        }}
                      >
                        1画面
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='layout-tool__label'>
                <div className='label'>
                  <span>画面分割</span>
                </div>
              </div>
            </div>
            {splitItem > 1 ? <span className='border-left' /> : null}
            <div
              className={
                splitItem > 1
                  ? 'order_type_footer_show'
                  : 'order_type_footer_hidden'
              }
            >
              <div className='order_type order_type_footer '>
                <button className='btn-text sortdate'>
                  <i className='i-check' /> <label>日別</label>
                </button>
                <button className='btn-text layout__inactive sortplace'>
                  <i className='i-check' /> <label>場所別</label>
                </button>
              </div>
              <div className='label_footer_order_type'>表示形式</div>
            </div>
          </div>
          <div
            className={
              splitItem > 1
                ? 'order_type_footer_show layout-tool__item layout-canvas__--btn'
                : 'order_type_footer_hidden layout-tool__item layout-canvas__--btn'
            }
          >
            <div className='layout-canvas__left--btn'>
              <button className='tool-btn btn-icon-sys-navi-next-prev sys_navi_prev btn-icon'>
                <i className='i-3x'>
                  <ToolPrevIcon />
                </i>
              </button>
            </div>
            <div className='layout-tool__label'>
              <div className='label'>
                <span>前へ</span>
              </div>
            </div>
          </div>
          <div
            className={
              splitItem > 1
                ? 'order_type_footer_show layout-tool__item layout-canvas__--btn'
                : 'order_type_footer_hidden layout-tool__item layout-canvas__--btn'
            }
          >
            <div className='layout-canvas__right--btn'>
              <button className='tool-btn btn-icon-sys-navi-next-prev sys_navi_next btn-icon'>
                <i className='i-3x'>
                  <ToolNextIcon />
                </i>
              </button>
            </div>
            <div className='layout-tool__label'>
              <div className='label'>
                <span>次へ</span>
              </div>
            </div>
          </div>
          <div className='layout-tool__group layout-tool__group--end'>
            <div
              className={
                splitItem > 1
                  ? 'order_type_footer_hidden'
                  : 'order_type_footer_fix'
              }
            >
              <div className='layout-tool__item'>
                <button className='tool-btn toolbar-zoomdown btn-icon'>
                  <i className='i-3x' alt='ズーム-'>
                    <ToolZoomDownIcon />
                  </i>
                </button>
                <div className='layout-tool__label'>
                  <div className='label'>
                    <span>縮小</span>
                  </div>
                </div>
              </div>
              <div className='layout-tool__item'>
                <button className='tool-btn toolbar-zoomup btn-icon'>
                  <i className='i-3x' alt='ズーム+'>
                    <ToolZoomUpIcon />
                  </i>
                </button>
                <div className='layout-tool__label'>
                  <div className='label'>
                    <span>拡大</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                splitItem > 1
                  ? 'order_type_footer_hidden'
                  : 'order_type_footer_fix'
              }
            >
              <div className='layout-tool__item'>
                <div id='dropdown-zoom-level' className='tool-item--sm'>
                  <div className='tool-item--sm__header'>
                    <div className='input-spin--sm' alt='zoom'>
                      <input readOnly type='text' />
                      <div className='btn-spin--sm'>
                        <div className='btn-icon select-up-reverse'>
                          {iconArrow(true, true)}
                        </div>
                        <div className='dropdown-icon btn-icon select-down-reverse'>
                          {iconArrow(false, true)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='tool-item--sm__body select-zoom'>
                    <ul className='dropdown-tool-list'>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='800%'>
                          800%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='700%'>
                          700%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='600%'>
                          600%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='500%'>
                          500%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='400%'>
                          400%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='300%'>
                          300%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='250%'>
                          250%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='200%'>
                          200%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='175%'>
                          175%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='150%'>
                          150%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='125%'>
                          125%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='100%'>
                          100%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='75%'>
                          75%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='50%'>
                          50%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='25%'>
                          25%
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='layout-tool__label'>
                  <div className='label'>
                    <span>表示倍率</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id='modal-dialog-object-info' className='modal '>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>情報</span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='layout-dialog-info'>
                <div className='layout-dialog-info__title'>作成者</div>
                <div className='layout-dialog-info__body'>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      会社名 ：
                    </div>
                    <div
                      id='dlg-info-creater-company'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      氏名 ：
                    </div>
                    <div
                      id='dlg-info-creater'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      作成日時 ：
                    </div>
                    <div
                      id='dlg-info-created'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                </div>
              </div>
              <div className='layout-dialog-info'>
                <div className='layout-dialog-info__title'>更新者</div>
                <div className='layout-dialog-info__body'>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      会社名 ：
                    </div>
                    <div
                      id='dlg-info-updater-company'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      氏名 ：
                    </div>
                    <div
                      id='dlg-info-updater'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      更新日時 ：
                    </div>
                    <div
                      id='dlg-info-updated'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                </div>
              </div>
              <div className='layout-dialog-info'>
                <div id='dlg-info-lock' className='layout-dialog-info__title'>
                  ロック状態 ON/OFF
                </div>
                <div className='layout-dialog-info__body'>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      会社名 ：
                    </div>
                    <div
                      id='dlg-info-locker-company'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      氏名 ：
                    </div>
                    <div
                      id='dlg-info-locker'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                  <div className='layout-dialog-info__item'>
                    <div className='layout-dialog-info__item-label'>
                      ロック日時 ：
                    </div>
                    <div
                      id='dlg-info-locked'
                      className='layout-dialog-info__item-value'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-add-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ追加
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名</div>
                <div className='dialog-layout-parts__input'>
                  <input
                    name='group_name'
                    type='text'
                    placeholder='グループ名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog sys_submit'>追加する</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-edit-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ編集
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名</div>
                <div className='dialog-layout-parts__input'>
                  <input type='hidden' name='group_id' />
                  <input
                    type='text'
                    name='group_name'
                    placeholder='グループ名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
              <button className='btn-layout-dialog--effective sys_submit'>
                更新
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-delete-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ削除確認
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名：</div>
                <div className='label' name='group_name' />
              </div>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループを削除しますか？</div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-add-parts' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>部品編集</span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>部品名</div>
                <div className='dialog-layout-parts__input'>
                  <input type='hidden' name='group_id' />
                  <input type='hidden' name='parts_id' />
                  <input
                    type='text'
                    name='parts_name'
                    placeholder='部品名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
              <button className='btn-layout-dialog--effective sys_submit'>
                更新
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-select-bg-image' className='modal'>
          <div className='dialog-sm dialog--modal'>
            <div className='dialog-sm__header'>
              <span className='dialog-sm__title'>背景選択</span>
            </div>
            <div className='dialog-sm__body text-center'>
              PDF、JPEG、GIF、PNGファイルをアップロードしてください。 <br />
              印刷用画像は、職長さんが様々な場所で閲覧する可能性があるため、十分に考慮してアップロードしてください。
            </div>
            <div className='dialog-sm__footer'>
              <button className='btn--sub sys_cancel'>戻る</button>
              <button className='btn--negative sys_clear'>クリアする</button>
              <label htmlFor='bgimage-upload' className='btn sys_select'>
                <input
                  id='bgimage-upload'
                  name='bgimage'
                  type='file'
                  accept='.gif, .jpg, .jpeg, .pdf, .png'
                  style={{ display: 'none' }}
                />
                変更する
              </label>
            </div>
          </div>
        </div>
        <div id='modal-dialog-preview-bg-image' className='modal'>
          <div className='dialog--cropper dialog--modal'>
            <div className='dialog-sm__header'>
              <h2 className='title-modal__cropper'>背景画像の切り抜き</h2>
            </div>
            <h3 className='intro-modal__cropper text-center'>
              ハンドルをドラッグして切り抜く範囲を変更できます。
            </h3>
            <div className='dialog-sm__body modal-cropper__body'>
              <main className='cropper-main'>
                <img id='preview' />
                <div className='cropper-body'>
                  <div className='cropper-preview'>
                    <canvas id='bg-canvas' />
                  </div>
                </div>
              </main>
            </div>
            <div className='dialog-sm__footer modal-cropper__footer'>
              <button className='btn--sub btn-cropper btn-cropper__cancel close'>
                キャンセル
              </button>
              <button
                className='btn btn-cropper btn-cropper__preview'
                id='submitPreview'
              >
                決定
              </button>
            </div>
          </div>
        </div>
        <div id='modal-dialog-split-view' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>表示対象を選択</span>
            </div>
            <div className='dialog-md__body'>
              <input type='hidden' name='split_date' />
              <input type='hidden' name='split_place_id' />
              <input type='hidden' name='split_place' />
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button
                onClick={() => {
                  this.setNumberSplitItem(1);
                }}
                className='btn-layout-dialog sys_edit'
              >
                編集する
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-copy-select' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>コピー元を選択</span>
            </div>
            <div className='entrance-exit-dialog-md__body'>
              <table className='entrance-exit-dialog-form'>
                <tbody>
                  <tr>
                    <td className='entrance-exit-dialog-form__label'>
                      <span className='label'>日付</span>
                    </td>
                    <td className='entrance-exit-dialog-form__element'>
                      <div
                        id='dropdown-copy-calendar'
                        className='dropdown-calender entrance-exit-dialog-dropdown__length'
                      >
                        <div className='dropdown-calender__input'>
                          <input type='text' name='copy_date' />
                          <div className='btn-spin'>
                            <div className='select-up btn-icon sys-calender-day-down'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='select-down btn-icon sys-calender-day-up'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                        <div
                          className='dropdown-calender__calender entrance-exit-dialog-form__length'
                          id='global-header-popup-calender-block-end'
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className='entrance-exit-dialog-form__label'>
                      <span className='label'>場所</span>
                    </td>
                    <td className='entrance-exit-dialog-form__element'>
                      <div
                        id='form-dropdown-6'
                        className='dropdown-single-select select-copy-place'
                      >
                        <div className='dropdown-single-select__header'>
                          <input name='copy_place_id' type='hidden' />
                          <input name='copy_place_name' type='hidden' />
                          <a
                            id='form-dropdown-6-btn'
                            href='javascript:void(0);'
                            className='dropdown-select entrance-exit-dialog-dropdown__length'
                          >
                            <span className='dropdown-select__txt copy_place_name_label'>
                              場所
                            </span>
                          </a>
                        </div>
                        <div
                          id='form-dropdown-6-list'
                          className='dropdown dropdown--dropdown-single-select'
                        >
                          <div className='dropdown__item'>
                            <div className='dropdown-single-select__item'>
                              <i className='i-search i-2x' />
                              <input
                                type='text'
                                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                                placeholder={messageUtility.getMessage(
                                  'I-000-090'
                                )}
                              />
                            </div>
                            <div className='dropdown-single-select__scroll'>
                              <ul className='single-select copy-place-list' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='entrance-exit-dialog-form__footer'>
              <button
                id='modal-close-disable-time'
                className='btn--sub sys_cancel'
              >
                戻る
              </button>
              <button className='btn sys_submit'>選択をコピーする</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-lock-okng' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>ロック確認</span>
            </div>
            <div className='dialog-md__body text-center'>
              表示中の現場配置計画をロックしますか？ <br />
              ※編集ロック後、職長は予定の新規追加と編集ができなくなります。
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                いいえ
              </button>
              <button className='btn-layout-dialog sys_submit'>はい</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-unlock-okng' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>ロック解除確認</span>
            </div>
            <div className='dialog-md__body text-center'>
              表示中の現場配置計画をロック解除しますか？ <br />
              ※編集ロック解除後、職長は予定の新規追加と編集が行えるようになります。
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                いいえ
              </button>
              <button className='btn-layout-dialog sys_submit'>はい</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-clearvackground-okng' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>背景クリア確認</span>
            </div>
            <div className='dialog-md__body text-center'>
              設定した背景を削除しますか？
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                いいえ
              </button>
              <button className='btn-layout-dialog sys_submit'>はい</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-clearvackground-okng' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>背景クリア確認</span>
            </div>
            <div className='dialog-md__body text-center'>
              設定した背景を削除しますか？
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                いいえ
              </button>
              <button className='btn-layout-dialog sys_submit'>はい</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-print' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>印刷</span>
            </div>
            <div className='dialog-md__body'>
              <div className='panel'>
                <div className='panel-header'>
                  <div className='form-element'>
                    <div className='form-element__label'>
                      <span className='label'>印刷対象期間</span>
                    </div>
                    <div className='form-element__element'>
                      <div className='form-element-horizontal'>
                        <div className='form-element-horizontal__item'>
                          <div
                            id='dropdown-calendar-print-from'
                            className='dropdown-calender'
                          >
                            <div className='dropdown-calender__input'>
                              <input
                                name='date_from'
                                type='text'
                                className='--col-xl-2 --col-lg-2 --col-md-3 --col-xs-3'
                                placeholder='（例）2020/01/01'
                                autoComplete='off'
                              />
                              <div className='btn-spin'>
                                <div className='select-up btn-icon sys-calender-day-down'>
                                  {iconArrow(true, true)}
                                </div>
                                <div className='select-down btn-icon sys-calender-day-up'>
                                  {iconArrow(false, true)}
                                </div>
                              </div>
                            </div>
                            <div className='dropdown'>
                              <div className='dropdown-calender__calender' />
                            </div>
                          </div>
                        </div>
                        <div className='form-element-horizontal__item'>-</div>
                        <div className='form-element-horizontal__item'>
                          <div
                            id='dropdown-calendar-print-to'
                            className='dropdown-calender'
                          >
                            <div className='dropdown-calender__input'>
                              <input
                                name='date_to'
                                type='text'
                                className='--col-xl-2 --col-lg-2 --col-md-3 --col-xs-3'
                                placeholder='（例）2020/01/01'
                                autoComplete='off'
                              />
                              <div className='btn-spin'>
                                <div className='select-up btn-icon sys-calender-day-down'>
                                  {iconArrow(true, true)}
                                </div>
                                <div className='select-down btn-icon sys-calender-day-up'>
                                  {iconArrow(false, true)}
                                </div>
                              </div>
                            </div>
                            <div className='dropdown'>
                              <div className='dropdown-calender__calender' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className='form-element__element'
                      style={{ fontSize: '0.8em' }}
                    >
                      (印刷対象期間は1か月以内になるように指定してください。)
                    </div>
                    <div className='form-element__element'>
                      <div className='form-element-horizontal'>
                        <div className='form-element-horizontal__item'>
                          {/**
                             <label htmlFor='sys_check_all' className='checkbox'>
                             <input
                             type='checkbox'
                             id='sys_check_all'
                             name='sys_check_all'
                             />
                             <i className='i-square i-3x' aria-hidden='true' />
                             すべてチェック
                             </label>
                             */}
                          &nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='panel-body'>
                  <div className='panel-list print-place-table'>
                    <div className='print-place-table-element'>
                      <table className='table'>
                        <tbody />
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-fixedsize--sub sys_cancel'>戻る</button>
              <button className='btn-fixedsize sys_print'>印刷</button>
            </div>
          </div>
        </div>

        <div style={{ display: 'none' }}>
          <input type='file' id='plan-upload' accept='image/jpeg, image/png' />
          <input
            type='file'
            id='image-upload'
            name='image'
            accept='.gif, .jpg, .jpeg, .png'
          />
          <input type='file' id='parts-upload' accept='image/jpeg, image/png' />
        </div>

        <div id='modal-dialog-popup-message' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>メッセージ</span>
            </div>
            <div className='dialog-md__body text-center message_text' />
            <div className='dialog-md__footer'>
              <button className='btn--sub sys_cancel'>戻る</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-goback-placeList' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>メッセージ</span>
            </div>
            <div className='dialog-md__body text-center message_text' />
            <div className='dialog-md__footer'>
              <button
                className='btn-layout-dialog--sub sys_cancel'
                onClick={() => this.placeList()}
              >
                戻る
              </button>
            </div>
          </div>
        </div>

        <div id='modal-loading-popup-message' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>メッセージ</span>
            </div>
            <div className='dialog-md__body text-center message_text' />
          </div>
        </div>

        <div id='modal-dialog-copy-nodata' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>メッセージ</span>
            </div>
            <div className='dialog-md__body text-center'>
              コピー元にデータがありません
            </div>
            <div className='dialog-md__footer-horizontal'>
              <button className='btn-fixedsize--sub sys_cancel'>戻る</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Layout.jsx